export var Paths;

(function (Paths) {
  Paths["ListPosts"] = "/me/community/questions";
  Paths["ListReplies"] = "/me/community/replies";
})(Paths || (Paths = {}));